<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Learning Goal Quizzes</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Learning Goal Quizzes</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="LearningGoalQuiz">
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
              <div class="card-tools">
                <router-link
                  class="btn btn-info"
                  :to="{ name: 'LearningGoalQuizList' }"
                  ><i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-8">
                  <div class="form-group required">
                    <label class="control-label">Learning Goal</label>
                    <multiselect
                      id="learning_goal_id"
                      name="learning_goal_id"
                      :options="Object.keys(pre.learning_goal_id)"
                      :custom-label="(opt) => pre.learning_goal_id[opt]"
                      v-bind:class="{
                        'has-error': errors.has('learning_goal_id'),
                      }"
                      v-validate="'required'"
                      v-model="inputs.learning_goal_id"
                      class="learning_goal_id"
                      placeholder="Select Learning Goal"
                      :searchable="true"
                      :close-on-select="true"
                      :show-labels="false"
                    ></multiselect>
                    <div
                      class="help text-danger"
                      v-show="errors.has('learning_goal_id')"
                    >
                      {{ errors.first("learning_goal_id") }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Question type</label>
                    <div class="form-group">
                      <el-select
                        v-model="inputs.question_type"
                        name="question_type"
                        placeholder="select question type"
                        v-validate="'required'"
                        @change="resetCorrectAnswer"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in [
                            { value: 'mcq', label: 'MCQ' },
                            { value: 'true_false', label: 'True/False' },
                          ]"
                          :key="item.value"
                          v-bind:class="{
                            'has-error': errors.has('question_type'),
                          }"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                      <div
                        class="help text-danger"
                        v-show="errors.has('question_type')"
                      >
                        {{ errors.first("question_type") }}
                      </div>
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Question</label>
                    <input
                      type="text"
                      id="question"
                      name="question"
                      v-bind:class="{ 'has-error': errors.has('question') }"
                      v-validate="'required'"
                      v-model="inputs.question"
                      class="form-control question"
                      placeholder="Question"
                    />
                    <div
                      class="help text-danger"
                      v-show="errors.has('question')"
                    >
                      {{ errors.first("question") }}
                    </div>
                  </div>

                  <component
                    :is="questionFieldsDecider"
                    :inputs="inputs"
                  ></component>

                  <!-- <div class="form-group required">
                    <label class="control-label">Duration in seconds</label>
                    <input type="number" id="duration_seconds" name="duration_seconds"
                           v-validate="'required|min:-1|max:120'"
                           v-model="inputs.duration_seconds" class="form-control"
                           placeholder="Duration in seconds">
                    <div class="help text-danger" v-show="errors.has('duration_seconds')">
                      {{ errors.first("duration_seconds") }}
                    </div>
                  </div> -->
                  <div class="form-group required">
                    <label class="control-label">Default mark</label>
                    <input
                      type="number"
                      id="default_mark"
                      name="default_mark"
                      v-validate="'required|min:1|max:5'"
                      v-model="inputs.default_mark"
                      class="form-control"
                      placeholder="Default mark"
                    />
                    <div
                      class="help text-danger"
                      v-show="errors.has('default_mark')"
                    >
                      {{ errors.first("default_mark") }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Display order</label>
                    <input
                      type="text"
                      id="display_order"
                      name="display_order"
                      v-model="inputs.display_order"
                      class="form-control"
                      placeholder="Display order"
                    />
                    <div
                      class="help text-danger"
                      v-show="errors.has('display_order')"
                    >
                      {{ errors.first("display_order") }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Is published</label>
                    <div class="form-group">
                      <el-select
                        v-model="inputs.is_published"
                        name="is_published"
                        style="width: 100%"
                        placeholder="select published status"
                        v-validate="'required'"
                      >
                        <el-option
                          v-for="item in [
                            { value: 'Yes', label: 'Yes' },
                            { value: 'No', label: 'No' },
                          ]"
                          :key="item.value"
                          v-bind:class="{
                            'has-error': errors.has('is_published'),
                          }"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                      <div
                        class="help text-danger"
                        v-show="errors.has('is_published')"
                      >
                        {{ errors.first("is_published") }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button type="submit" v-if="!is_edit" class="btn btn-primary">
                Submit
              </button>
              <button type="submit" v-if="is_edit" class="btn btn-primary">
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "LearningGoalQuizForm",
  metaInfo: {
    title: "Learning Goal Quizzes | Dotlines",
  },
  components: {
    McqQuestionFields: () => import("./components/McqQuestionFields"),
    TrueFalseQuestionFields: () =>
      import("./components/TrueFalseQuestionFields"),
  },
  data: () => ({
    is_loading: false,
    is_edit: false,
    params: {},
    inputs: {
      default_mark: 1,
      duration_seconds: -1,
      display_order: 9999,
    },
    pre: {
      learning_goal_id: {},
    },
  }),
  computed: {
    questionFieldsDecider() {
      if (this.inputs.question_type === "mcq") {
        return "McqQuestionFields";
      } else if (this.inputs.question_type === "true_false") {
        return "TrueFalseQuestionFields";
      }
    },
  },
  provide() {
    return {
      $validator: this.$validator,
    };
  },
  methods: {
    learningGoalIdOptions: function () {
      return new Promise((resolve, reject) => {
        axios
          .get("/get-dropdown-options/10")
          .then((response) => {
            resolve(response.data);
            //return response.data;
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },

    resetCorrectAnswer() {
      this.inputs.correct_options = "";
    },

    handleSubmission() {
      let _this = this;
      _this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/learning_goal_quizzes";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/learning_goal_quizzes/" + _this.$route.params.id;
            method = "PUT";
          }
          axios({
            method: method,
            url: api_url,
            data: _this.inputs,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.$router.push({ name: "LearningGoalQuizList" });
            })
            .catch((errors) => {
              _this.$setErrorsFromResponse(errors.response.data);
              _this.$toaster.error(errors.response.data.message);
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },

    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/learning_goal_quizzes/" + id;
        axios
          .get(api_url)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;
      await this.learningGoalIdOptions().then((learning_goal_id) => {
        this.pre.learning_goal_id = learning_goal_id;
      });

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then((response) => {
            this.inputs = response.data;
          })
          .catch((error) => {
            console.log(error.response);
          });
      }
      this.is_loading = false;
    },
  },
  mounted() {
    this.initialize();
  },
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
};
</script>
